
import { router } from "@/router";
import StorageService from "@/services/StorageService";
import { closePage, openPage } from "@/utils/patientLoggerPage";
import { Vue } from "vue-class-component";

export default class NotFound extends Vue {
  viewName = "NotFound";
  patientLoggerPageId: number | undefined;
  user: any = null;
  private storageService = new StorageService();

  async mounted() {
    this.user = this.storageService.getUser();
    this.patientLoggerPageId = await openPage(
      this.viewName,
      this.user.patientsId
    );
  }

  async beforeUnmount() {
    if (this.patientLoggerPageId && this.storageService.getUser()) {
      await closePage(this.patientLoggerPageId, this.user.patientsId);
    }
  }

  moveToHomepage() {
    router.push({ name: "Home" });
  }
}
